"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const apollo_1 = require("../apollo");
const init = ({ dispatch }) => {
    // initServerConfig({ userServiceAddress });
    (0, apollo_1.initApolloParameters)({
        dispatch,
    });
};
exports.init = init;
